import type { AccountIRR, AccountIRRWindow, Horizons } from "wealthmode-frontend"
import { Text, VStack } from "wealthmode-frontend/gluestack/ui"

import { IRR_COLORS, compareIRRToMarket, formatIRR, formatIRRAgainstMarket, showsAdjusted } from "@/lib/irr"

/** An account's IRR, with its adjusted IRR beneath it where the two read differently. */
export function IRRValues({ irr, plain }: { irr: AccountIRR | null; plain?: boolean }) {
  const base = irr?.base ?? null
  const adjusted = irr?.adjusted ?? null
  const window = irr?.window ?? null
  const market = irr?.market ?? null

  return (
    <VStack>
      <IRRValue
        rate={base}
        window={window}
        market={market}
        plain={plain}
      />
      {showsAdjusted(base, adjusted) && (
        <IRRValue
          rate={adjusted}
          window={window}
          market={market}
          plain={plain}
        />
      )}
    </VStack>
  )
}

/**
 * An IRR as its rate and the day its window opened, set against the market over the same days and
 * colored by how it stands against it. Plain shows the rate and window alone, uncolored, for an
 * account the market says nothing about.
 */
export function IRRValue({
  rate,
  window,
  market,
  plain,
}: {
  rate: Horizons | null
  window: AccountIRRWindow | null
  market: number | null
  plain?: boolean
}) {
  if (plain) {
    return <Text className="text-foreground-secondary">{formatIRR(rate, window)}</Text>
  }

  return (
    <Text className={IRR_COLORS[compareIRRToMarket(rate, market)]}>{formatIRRAgainstMarket(rate, window, market)}</Text>
  )
}
